//console.log("ready c");

//    $("a.product-link").mouseover(function () {
//      $(this)
//        .closest(".product-block__detail")
//        .find(".product-block-options")
//        .css("visibility", "visible");
//    });


  // Trova l'elemento .product-block-options relativo all'elemento sul quale il mouse ha lasciato e ripristina la visibilità
//  $("a.product-link").mouseout(function () {
//    $(this)
//      .closest(".product-block__detail")
//      .find(".product-block-options")
//      .css("visibility", "hidden");
//  });

function filtrabrand() {
}
function filtrabrand2() {
  var input, filter, ul, li, a, i;
  input = document.getElementById("Filter-myBrandInput");
  filter = input.value.toUpperCase();
  div = document.getElementById("filter-group--3");

  a = div.getElementsByTagName("label");
  for (i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].style.display = "block";
    } else {
      a[i].style.display = "none";
    }
  }
}


$( "#myBrandInput" ).on( "keyup", function() {
  filtrabrand();
} );


//  $("#myBrandInput").focusin(function(){
//    $(this).css("background-color", "#FFFFCC");
//    $('#myBrandInput').val(" x");    
//  });
//  $("#myBrandInput").focusout(function(){
//    $(this).css("background-color", "#00FFFF");
//    $('#myBrandInput').remove();
//alert();
//$("#myBrandInput").attr('disabled','disabled');
//  });


